export default __webpack_public_path__ + "static/media/icon-congrats.7e12f4ec.svg";